import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { PagedResponse } from 'mbs-ui-shared@models/Paging';
import { Observable } from 'rxjs';
import { PurchaseHistory, PurchaseHistoryParams, TransactionDetailsResponse } from '../models/purchase-history.types';

@Injectable({
  providedIn: 'root'
})
export class PurchaseHistoryService {
  private http = inject(HttpClient);

  private readonly baseHref = '/api/purchase-history';

  public getHistory(params: PurchaseHistoryParams) {
    return this.http.get<PagedResponse<PurchaseHistory>>(`${this.baseHref}`, { params });
  }

  public exportHistory(params: PurchaseHistoryParams): Observable<any> {
    return this.http.get(`${this.baseHref}/export`, { params, responseType: 'text' });
  }

  public getDetails(id: string): Observable<TransactionDetailsResponse> {
    return this.http.get<TransactionDetailsResponse>(`${this.baseHref}/${id}/details`);
  }

  public getInvoicePdf(id: string) {
    return this.http.get(`${this.baseHref}/${id}/invoice`, { observe: 'response', responseType: 'blob' });
  }

  public getReceiptPdf(id: string) {
    return this.http.get(`${this.baseHref}/${id}/receipt`, { observe: 'response', responseType: 'blob' });
  }
}
